<mat-toolbar>

    <!-- Point of sale title + logo -->
    <div fxLayout="row" fxLayoutGap="5px" fxHide fxShow.xs style="overflow:hidden;">

        <div fxLayoutAlign="center center">
            <img [src]="(pointOfSale && pointOfSale.img) ? pointOfSale.img : 'assets/img/logo/logo-fulle-xs.png'"  class="h-10" style="border-radius: 50%;">
        </div>

        <div fxLayout="column" fxLayoutAlign="start space-between" style="white-space:normal">
            <span class="mat-subheading-1">{{pointOfSale?.denomination}}</span>
            <span class="mat-subheading-1 boldest">{{bookingSettings.name | descFilter:30}}</span>
        </div>

    </div>

    <div class="fill-rest"></div>

    <!-- Register - login  -->
    <div fxLayout="row" fxHide.xs *ngIf="!currUser$">

        <button mat-button color="primary" class="head-btn" (click)="authPageServ.goRegister(redirectPage)" angulartics2On="click" angularticsAction="redirectRegister" angularticsCategory="headers">{{"main.word.register"
  |
  translate}}</button>

        <button mat-button color="primary" class="head-btn" (click)="authPageServ.goLogin(redirectPage)" angulartics2On="click" angularticsAction="redirectLogin" angularticsCategory="headers">{{"main.word.login"
  | translate}}</button>

    </div>

    <!-- Go Account if connected -->
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">

        <div fxHide.xs>

            <a *ngIf="currUser$" fxLayoutAlign="center center" target="_blank" [routerLink]="['/home']" angulartics2On="click" angularticsAction="redirectCustomerSpaceFromHeaderOrder" angularticsCategory="customerSpace">
                <img src="{{currUser$.photoURL}}" class="head-user-img clicked rad-bord" target="blank" *ngIf="currUser$.photoURL">
                <img src="assets/img/user/emptyuser.png" class="head-user-img clicked rad-bord" *ngIf="!currUser$.photoURL">
            </a>
        </div>

        <mat-icon *ngIf="currUser$ || !currUser$ && media.isActive('xs')" class="clicked" [matMenuTriggerFor]="menu" angulartics2On="click" angularticsAction="redirectProduct" angularticsCategory="headers">more_vert</mat-icon>

    </div>

    <!-- Menu -->
    <mat-menu #menu="matMenu" angulartics2On="click" angularticsAction="redirectCustomerSpace">

        <ng-template matMenuContent>

            <button *ngIf="conditionWebShop()" mat-menu-item (click)="goWebShop()" angulartics2On="click" angularticsAction="goWebShop" angularticsCategory="headers">
                <mat-icon>shopping_cart</mat-icon>
                <span>Boutique en ligne</span>
              </button>

            <a fxHide fxShow.xs *ngIf="currUser$" target="_blank" [routerLink]="['/home']">
                <button *ngIf="currUser$" mat-menu-item angulartics2On="click" angularticsAction="openMenu" angularticsCategory="headers">
      <mat-icon>account_circle</mat-icon>
      <span>Mon espace</span>
    </button>
            </a>

            <button fxHide fxShow.xs *ngIf="!currUser$" mat-menu-item (click)="authPageServ.goRegister(redirectPage)" angulartics2On="click" angularticsAction="redirectRegisterFromMenu" angularticsCategory="headers">
    <span>{{"main.word.register" | translate}}</span>
  </button>

            <button fxHide fxShow.xs *ngIf="!currUser$" mat-menu-item (click)="authPageServ.goLogin(redirectPage)" angulartics2On="click" angularticsAction="redirectLoginFromMenu" angularticsCategory="headers">
    <span>{{"main.word.login" | translate}}</span>
  </button>

            <button *ngIf="currUser$" mat-menu-item (click)="logOut()" angulartics2On="click" angularticsAction="logout" angularticsCategory="headers">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{"header.menu.logout" | translate}}</span>
  </button>

        </ng-template>

        <div fxLayoutAlign="center center" class="layout-padd">
            <app-version></app-version>
        </div>

    </mat-menu>

</mat-toolbar>
